import React, { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { Container } from "react-bootstrap";

import { Navbar } from "./navbar";
import { Footer } from "./footer";
import useScrollToTop from "hooks/useScrollToTop";

import styles from "./landing-layout.module.scss";

interface LandingLayoutProps {
  children?: ReactNode;
}
export const LandingLayout: React.FC<LandingLayoutProps> = ({ children }) => {
  useScrollToTop();

  return (
    <div className={styles.landing_container}>
      <div className={styles.navbar_container}>
        <Container>
          <Navbar />
        </Container>
      </div>
      <Outlet />
      {children}
      
      <Footer />
    </div>
  );
};
